import MarkdownIt from "markdown-it";
const md = new MarkdownIt();

export function MarkdownViewer({ value }: { value: string }) {
  const rendered = md.render(value);
  return <span dangerouslySetInnerHTML={{ __html: rendered }} />;
}
